import { render, staticRenderFns } from "./Menus.vue?vue&type=template&id=1325f9e0&"
import script from "./Menus.vue?vue&type=script&lang=js&"
export * from "./Menus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports